import React from 'react'

export default function About() {
	return (
		<React.Fragment>
			<h1>About</h1>
			<p>This is a Todo List app. My first ever made application using React.</p>
		</React.Fragment>
	)
}

export { About };